import { createFileRoute, Outlet } from '@tanstack/react-router';

import { PostsLayout } from '#modules/user/features/dashboard/components/PostsLayout';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/discover/posts/_posts'
)({
  component: LayoutComponent,
  ssr: false,
});

function LayoutComponent() {
  return (
    <PostsLayout>
      <Outlet />
    </PostsLayout>
  );
}
